module.exports = __webpack_public_path__ + "img/menu_icon_tag.ef0dd3c0.svg";